export const Google = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4483 5.32812L10.7064 8.24839L6.87891 5.32812V5.32891L6.88353 5.33286V9.42202L10.6632 12.4054L14.4483 9.53725V5.32812Z"
      fill="#EA4335"
    />
    <path
      d="M15.4319 4.61649L14.4492 5.32683V9.53595L17.5414 7.16185V5.73172C17.5414 5.73172 17.1661 3.68911 15.4319 4.61649Z"
      fill="#FBBC05"
    />
    <path
      d="M14.4492 9.5362V14.9955H16.8192C16.8192 14.9955 17.4936 14.9261 17.5422 14.1573V7.16211L14.4492 9.5362Z"
      fill="#34A853"
    />
    <path d="M6.88371 15.0012V9.42192L6.87891 9.41797L6.88371 15.0012Z" fill="#C5221F" />
    <path
      d="M6.88055 5.32686L5.90325 4.62047C4.16909 3.69309 3.79297 5.7349 3.79297 5.7349V7.16504L6.88055 9.41601V5.32686Z"
      fill="#C5221F"
    />
    <path d="M6.87891 5.32812V9.41728L6.88371 9.42123V5.33207L6.87891 5.32812Z" fill="#C5221F" />
    <path
      d="M3.79297 7.16797V14.1632C3.84075 14.9327 4.51592 15.0014 4.51592 15.0014H6.88595L6.88055 9.41815L3.79297 7.16797Z"
      fill="#4285F4"
    />
  </svg>
)

export default Google
